import { cn } from "@/lib/utils";
import { ChevronLeftIcon } from "lucide-react";
import type { ComponentProps } from "react";
import { Link } from "react-router-dom";

interface PageHeaderLinkProps
	extends Omit<ComponentProps<typeof Link>, "children" | "to"> {
	label: string;
	to?: ComponentProps<typeof Link>["to"];
}

export const PageHeaderLink = ({
	label,
	to = "/",
	className,
	...props
}: PageHeaderLinkProps) => {
	return (
		<Link
			to={to}
			className={cn(
				"text-muted-foreground hover:text-foreground inline-flex items-center gap-1 text-sm",
				className,
			)}
			{...props}
		>
			<ChevronLeftIcon className="size-4" />
			{label}
		</Link>
	);
};
